import React from 'react';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';

var StepHeader = function StepHeader(_ref) {
  var icon = _ref.icon,
      header = _ref.header;
  return /*#__PURE__*/React.createElement("div", {
    className: "step-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step-header__icon-wrapper"
  }, /*#__PURE__*/React.createElement(ReactSVG, {
    src: icon,
    className: "step-header__icon"
  })), /*#__PURE__*/React.createElement("h5", {
    className: "step-header__title"
  }, header));
};

export default StepHeader;
StepHeader.propTypes = {
  icon: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired
};